import { PHOTOGRAPH_WIDTH_PX } from "@/data/Config";

export const renderTextBlock = async (
    captionText: string,
    captionColor: string,
): Promise<HTMLImageElement|null> =>
{
    const canvas = document.createElement("canvas");

    const canvasWidth = PHOTOGRAPH_WIDTH_PX;

    const ctx = canvas.getContext("2d");

    if (!ctx) return null;

    const fontSize = 20;
    const lineHeight = 28;
    const scale = canvasWidth / document.body.clientWidth;
    const canvasLineHeight = lineHeight * scale;


    ctx.font = `bold ${(fontSize * scale)}px Poppins`;

    // Set Canvas Size
    canvas.width = canvasWidth;
    canvas.height = 150;
    ctx.font = `bold ${(fontSize * scale)}px Poppins`;


    // Render the box based on the text. Add proper white-space: break-space word wrapping

    const words = captionText.split(" ");
    const lines = [];

    // Loop through the words and see if it fits the width of the canvas
    // If it does, add it to the current line
    // If it doesn't, start a new line and add the word to that line

    let currentLine = "";

    for (const word of words)
    {
        const wordWidth = ctx.measureText(`${currentLine} ${word}`).width;

        if (wordWidth < canvas.width)
        {
            currentLine += ` ${word}`;
        }
        else
        {
            lines.push(currentLine);
            currentLine = word;
        }
    }

    if (currentLine.length > 0)
    {
        lines.push(currentLine);
    }

    // Set Canvas Size
    canvas.width = canvasWidth;
    canvas.height = (lines.length * canvasLineHeight);


    // Render Input Box
    ctx.fillStyle = "rgba(0,0,0,0.5)";

    ctx.fillRect(
        0,
        0,
        canvas.width,
        canvas.height,
    );

    ctx.font = `bold ${(fontSize * scale)}px Poppins`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.imageSmoothingEnabled = true;

    ctx.fillStyle = captionColor;

    // ctx.fillText(captionText, canvas.width / 2, canvas.height / 2);

    // Render each line of text
    for (const line of lines)
    {
        ctx.fillText(
            line,
            canvas.width / 2,
            (lines.indexOf(line) * canvasLineHeight) + (canvasLineHeight / 2),
        );
    }


    const img = new Image();

    return new Promise((resolve) =>
    {
        img.onload = () =>
        {
            resolve(img);
        };

        img.src = canvas.toDataURL("image/png");
    });
};
